import styles from './EmptyPreview.module.css';

import React from 'react';

const EmptyPreview = ({ placeholder = 'Empty' }) => {
  return <span className={[styles.emptyPreview, placeholder === 'N/A' ? styles.emphasized : ''].join(' ')}>{placeholder}</span>;
};

export default EmptyPreview;
